// Mobile: abre/fecha sidebar deslizando
function toggleSidebar() {
  const sidebar = document.getElementById('sidebar')
  const icon = document.getElementById('menu-icon')

  if (sidebar.classList.contains('-translate-x-full')) {
    sidebar.classList.remove('-translate-x-full')
    icon.classList.remove('fa-bars')
    icon.classList.add('fa-times')
  } else {
    sidebar.classList.add('-translate-x-full')
    icon.classList.remove('fa-times')
    icon.classList.add('fa-bars')
  }
}

// Desktop: recolher/expandir sidebar
function toggleCollapse() {
  const sidebar = document.getElementById('sidebar')
  const main = document.getElementById('main-content')
  const isCollapsed = sidebar.classList.toggle('sidebar-collapsed')
  main.classList.toggle('sidebar-is-collapsed', isCollapsed)
  localStorage.setItem('sidebar-collapsed', isCollapsed ? '1' : '0')
}

// Restaurar estado ao carregar
function restoreSidebarState() {
  if (window.innerWidth >= 768 && localStorage.getItem('sidebar-collapsed') === '1') {
    const sidebar = document.getElementById('sidebar')
    const main = document.getElementById('main-content')
    if (sidebar) sidebar.classList.add('sidebar-collapsed')
    if (main) main.classList.add('sidebar-is-collapsed')
  }
}

// Tooltip do sidebar recolhido
// Elemento criado sob demanda e recriado se o Turbo remover do DOM
let tooltipEl = null

function getTooltip() {
  // Se o elemento foi removido do DOM pelo Turbo, descartar referencia
  if (tooltipEl && !document.body.contains(tooltipEl)) {
    tooltipEl = null
  }
  if (!tooltipEl) {
    tooltipEl = document.createElement('div')
    tooltipEl.className = 'sidebar-tooltip'
    document.body.appendChild(tooltipEl)
  }
  return tooltipEl
}

function hideTooltip() {
  if (tooltipEl && document.body.contains(tooltipEl)) {
    tooltipEl.classList.remove('visible')
  }
}

document.addEventListener('mouseover', function (e) {
  const link = e.target.closest('#sidebar.sidebar-collapsed .sidebar-nav-link[data-tooltip]')
  if (!link) {
    hideTooltip()
    return
  }

  const text = link.getAttribute('data-tooltip')
  if (!text) return

  const tip = getTooltip()
  tip.textContent = text
  const rect = link.getBoundingClientRect()
  tip.style.top = rect.top + rect.height / 2 + 'px'
  tip.style.left = rect.right + 10 + 'px'
  tip.style.transform = 'translateY(-50%)'
  tip.classList.add('visible')
})

document.addEventListener('mouseout', function (e) {
  const link = e.target.closest('#sidebar .sidebar-nav-link[data-tooltip]')
  if (!link) return
  hideTooltip()
})

// Expor globalmente (usado via onclick nos botoes do layout)
window.toggleSidebar = toggleSidebar
window.toggleCollapse = toggleCollapse

// Restaurar estado imediatamente (carga inicial)
restoreSidebarState()

// Restaurar estado apos navegacao do Turbo Drive
document.addEventListener('turbo:load', restoreSidebarState)
document.addEventListener('turbo:render', restoreSidebarState)
